module.exports = __webpack_public_path__ + "static/media/japanese-ship.8f448e89.png";